import styled from 'styled-components';

import { Text } from '@gympass/yoga';

import { Checkbox, Modal, Button } from 'components';

export const DeliverContent = styled(Modal)`
  outline: ${({ theme }) => theme.yoga.spacing.zero};
  min-width: ${({ theme }) => theme.yoga.sizes.deliverContentModalMinWidth}px;
  background: ${({ theme }) => theme.yoga.colors.white};
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  padding: ${({ theme }) => theme.yoga.spacing.zero}
    ${({ theme }) => theme.yoga.spacing.medium}px;
  overflow: auto;
`;

export const DeliverContentModalTitle = styled(Text.H5)`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const DeliverContentSearchContainer = styled.div`
  margin: ${({ theme }) => theme.yoga.spacing.small}px
    ${({ theme }) => theme.yoga.spacing.zero}px;
`;

export const TopicContent = styled.div`
  align-items: center;
  display: grid;
  grid-auto-flow: column;
  justify-content: left;
  padding: ${({ theme }) => theme.yoga.spacing.xxxsmall}px
    ${({ theme }) => theme.yoga.spacing.small}px;

  &:nth-child(odd) {
    background-color: ${({ theme }) => theme.yoga.colors.elements.disabled};
  }

  &:last-child {
    margin-bottom: ${({ theme }) =>
      theme.yoga.sizes.deliverContentLabelHeight}px;
  }
`;

export const Program = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: ${({ theme }) => theme.yoga.borders.small}px solid
    ${({ theme }) => theme.yoga.colors.tableBorder};

  & + & {
    margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
  }

  strong {
    color: ${({ theme }) => theme.yoga.colors.text.primary};
  }

  button {
    outline: ${({ theme }) => theme.yoga.spacing.zero};
    border: ${({ theme }) => theme.yoga.spacing.zero};
    background: transparent;
    cursor: pointer;

    svg {
      fill: ${({ theme }) => theme.yoga.colors.primary};
      width: ${({ theme }) => theme.yoga.spacing.large}px;
      height: ${({ theme }) => theme.yoga.spacing.large}px;
    }
  }
`;

export const CustomCheckbox = styled(Checkbox)`
  display: block;

  & + & {
    margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
    margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;
    width: 100%;
  }

  > div > label {
    font-size: ${({ theme }) => theme.yoga.fontSizes.small}px;
    line-height: ${({ theme }) => theme.yoga.lineHeights.medium}px;
    color: ${({ theme }) => theme.yoga.colors.stamina};
    height: ${({ theme }) => theme.yoga.sizes.deliverContentLabelHeight}px;
    font-weight: ${({ theme }) => theme.yoga.fontWeights.medium}px;

    > div {
      border-color: ${({ theme }) => theme.yoga.colors.checkboxBorderColor};
    }

    > div:not(:empty) {
      background-color: ${({ theme, disabled }) =>
        disabled
          ? theme.yoga.colors.checkboxDisabled
          : theme.yoga.colors.primary};
      border: ${({ theme }) => theme.yoga.borders.zero};
    }
  }
`;

export const SendTopicsButton = styled(props => <Button {...props} />)`
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
  margin-top: ${({ theme }) => theme.yoga.spacing.medium}px;
`;

export const ProgramContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ProgramTitle = styled(Text.Medium)`
  margin-left: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const TopicTitle = styled(Text.Small)`
  color: ${({ theme }) => theme.yoga.colors.textSecondary};
  margin-left: ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
`;

export const CustomButton = styled(props => <Button {...props} />)`
  margin: auto;
  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const ConfirmModalContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CustomTextH5 = styled(Text.H5)`
  margin: auto;
  margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
  width: 400px;
  text-align: center;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.large}px;

  margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
  align-items: center;
  justify-content: center;

  button {
    margin: ${({ theme }) => theme.yoga.spacing.zero};
  }

  button:first-child {
    margin-right: ${({ theme }) => theme.yoga.spacing.xxxlarge}px;
  }
`;
